module.exports = __webpack_public_path__ + "img/11.a5958e1e.jpg";